<template>
  <layout :session="session" :participant="participant">
    <rating
      :session="session"
      :translations="translations"
      :participant="participant"
      :question="currentQuestion"
      :answerParameters="answerParameters"
    ></rating>

  </layout>
</template>

<script>
import Layout from '@/Pages/Live/Shared/Layout';
import Rating from '@/Pages/Live/Productivity/Questions/Rating';
import { findIndex } from 'lodash';

export default {
  components: {
    Layout,
    Rating,
  },

  props: ['session', 'participant', 'questions', 'phases', 'answerParameters', 'translations'],

  
  computed: {
    currentQuestion() {
      let idx = this.session.current_step_productivity.replace('question', '');

      return this.questions[(idx-1)];
    },

    // question() {
    //   return this.phases[this.session.current_phase].question.question;
    // },

    // currentQuestion() {
    //   let idx = findIndex(this.phases, phase => {
    //     return (
    //       phase.type == 'question' && phase.id == this.session.current_phase
    //     );
    //   });

    //   return this.phases[idx] !== undefined ? this.phases[idx].question : null;
    // }
  }
};
</script>